import React, { useState } from "react";
import { API_BASE_URL } from "./config";
import {BRAND, contrastText, getThemeColors, inputStyle} from "./themes";


async function postJSON(path, body) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || `Request failed (${res.status})`);
  }
  return data;
}

export default function Register({theme}) {
  const themeColors = getThemeColors(theme);
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(null); // {username, RemainingTurns}

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const emailTrim = email.trim().toLowerCase();
    if (!emailTrim) return setError("Email is required.");
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== pw2) return setError("Passwords do not match.");

    setLoading(true);
    try {
      const data = await postJSON("/register", { email: emailTrim, password: pw });
      setSuccess({ username: data.username, RemainingTurns: data.RemainingTurns });

      // optional: remember the email
      localStorage.setItem("loopen_email", emailTrim);

      // optional: redirect to login page after success
      // window.location.href = "/login";
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
      <div style={{ 
        padding: 28, 
        background: themeColors.background, 
        minHeight: '100vh',
        fontFamily: BRAND.font 
      }}>
        <img
          src="/logo_wordmark.png"
          alt="Loopen"
          style={{
            height: 48,
            width: 'auto',
            objectFit: 'contain',
            filter: theme === 'dark' ? 'invert(1) brightness(1.2)' : 'none',
            marginBottom: 8,
          }}
        />
        <div style={{ fontSize: 11, color: '#9aa4ad', marginBottom: 24 }}>by Lausanne Business Solutions</div>

        <div style={{ maxWidth: 480 }}>
          <div style={{
            background: themeColors.cardBg,
            borderRadius: 10,
            padding: 24,
            boxShadow: '0 6px 18px rgba(0,0,0,0.5)',
            border: `1px solid ${themeColors.borderColor}`,
          }}>
          {!success ? (
            <>
              <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 18, height: 18, borderRadius: 4, background: BRAND.accent }} />
                <div style={{ fontSize: 18, fontWeight: 700, color: themeColors.text }}>Create account</div>
              </div>
              <div style={{ fontSize: 14, color: themeColors.textMuted, marginBottom: 16 }}>
               Register with your email to start using the app.
              </div>
              <form onSubmit={onSubmit}>
                <label style={{ display: 'block', marginBottom: 12, color: themeColors.text, fontWeight: 600 }}>
                  Email
                  <input
                    style={{...inputStyle(themeColors), marginTop: 6}}
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </label>

                <label style={{ display: 'block', marginBottom: 12, color: themeColors.text, fontWeight: 600 }}>
                Password
                <input
                  style={{...inputStyle(themeColors), marginTop: 6}}
                  type="password"
                  placeholder="At least 8 characters"
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  autoComplete="new-password"
                  required
                />
              </label>
              <label style={{ display: 'block', marginBottom: 12, color: themeColors.text, fontWeight: 600 }}>
                Confirm password
                <input
                  style={{...inputStyle(themeColors), marginTop: 6}}
                  type="password"
                  placeholder="Re-enter password"
                  value={pw2}
                  onChange={(e) => setPw2(e.target.value)}
                  autoComplete="new-password"
                  required
                />
              </label>

              {error && (
                <div style={{ color: BRAND.error, fontSize: 14, marginTop: 4, marginBottom: 8, fontWeight: 500 }}>
                  {error}
                </div>
              )}
                <button
                  style={{
                    padding: '10px 14px',
                    borderRadius: 8,
                    background: BRAND.accent,
                    border: 'none',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    color: contrastText(BRAND.accent),
                    fontWeight: 600,
                    opacity: loading ? 0.7 : 1,
                    marginTop: 8,
                  }}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Creating…" : "Create account"}
                </button>

                <div style={{ fontSize: 12, color: themeColors.textMuted, marginTop: 12 }}>
                  By creating an account you agree to the terms.
                </div>
              </form>
            </>
          ) : (
            <>
              <div style={{ fontSize: 18, fontWeight: 700, color: themeColors.text, marginBottom: 12 }}>
                ✅ Account created
              </div>
              <div style={{ fontSize: 14, color: themeColors.textMuted, marginBottom: 20 }}>
                You're registered as <span style={{ fontFamily: 'monospace', color: themeColors.text }}>{success.username}</span>
              </div>
              <div style={{
                background: themeColors.inputBg,
                borderRadius: 8,
                padding: '12px 16px',
                border: `1px solid ${themeColors.borderColor}`,
                marginBottom: 20,
              }}>
                <div style={{ fontSize: 12, color: themeColors.textMuted }}>Remaining turns</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: themeColors.text }}>{success.RemainingTurns}</div>
              </div>
              
                <a href="/login"
                style={{
                  display: 'inline-block',
                  padding: '10px 14px',
                  borderRadius: 8,
                  background: themeColors.primary,
                  color: '#fff',
                  fontWeight: 600,
                  textDecoration: 'none',
                  fontSize: 14,
                }}
              >
                Go to Sign in
              </a>
            </>
          )}
        </div>
        <div style={{ fontSize: 12, color: '#9aa4ad', marginTop: 16 }}>
          © {new Date().getFullYear()} Loopen
        </div>
      </div>
    </div>
  );
}
